module.exports = {"460105001":"秀英街道","460105002":"海秀街道办","460105100":"长流镇","460105101":"西秀镇","460105102":"海秀镇","460105103":"石山镇","460105104":"永兴镇","460105105":"东山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/460105.json
// module id = 2007
// module chunks = 0